import moment from "moment";

import { ExpensesFormValuesProps } from "../components/modals/ExpenseModal/ExpenseModal.types";
import { ExpenseMediaTypes } from "../constants";
import { IExpense } from "../financial.types";

export const getInitialExpenseFormValues = (
  editableItem?: IExpense | null
): ExpensesFormValuesProps => {
  return {
    id: editableItem?.id ?? undefined,
    title: editableItem?.title ?? "",
    amount: editableItem?.amount ?? null,
    type: editableItem?.type ?? "",
    quantity: editableItem?.quantity ?? null,
    description: editableItem?.description ?? "",
    paymentMethod: editableItem?.paymentMethod ?? "Cash",
    paymentProofs:
      editableItem?.media
        ?.filter((item) => item.type === ExpenseMediaTypes.ProofOfPayment)
        .map((item) => item.media) ?? [],
    responsiblePersonName: editableItem?.responsiblePersonName ?? "",
    expenseProofs:
      editableItem?.media
        ?.filter((item) => item.type === ExpenseMediaTypes.Proof)
        .map((item) => item.media) ?? [],
    createdAt: moment(editableItem?.createdAt ?? new Date()).toDate()
  };
};
